<template>
  <div class="circle-progress">
    <svg :width="width" :height="width" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle :r="radius" :cx="width/2" :cy="width/2" fill="transparent" :style="cssCircle1Style"  ></circle>
      <circle :r="radius" :cx="width/2" :cy="width/2" fill="transparent" :style="cssCircle2Style"></circle>
    </svg>
    <span class="value" :class="{'highlight' : value===100}">{{value}}<i>%</i></span>
  </div>
</template>
<script>
export default {
  props: {
    value: Number,
    width: Number
  },
  computed: {
    // rayon du cercle
    radius () {
      return (this.width - 10) / 2
    },
    strokeDashArray () {
      var r = this.radius
      return Math.PI * (r * 2)
    },
    strokeDashOffset () {
      var val = this.value
      if (val < 0) { val = 0 }
      if (val > 100) { val = 100 }

      return ((100 - val) / 100) * this.strokeDashArray
    },
    cssCircle1Style () {
      return { 'stroke-dasharray': this.strokeDashArray }
    },
    cssCircle2Style () {
      return { 'stroke-dasharray': this.strokeDashArray, 'stroke-dashoffset': this.strokeDashOffset }
    }
  }
}
</script>
<style lang="less">
  @import '../assets/variables.less';

  .circle-progress {
    position: relative;
    margin-right: 1em;

    svg
    {
      transform: rotate(-90deg);
    }

  circle
  {
    transition: stroke-dashoffset .5s linear;
    stroke-dasharray: 0;
    stroke-dashoffset: 0;

    &:first-child
      {
        stroke-width: 3;
        stroke: @grey9;
        opacity: .3;
      }

      &:last-child {
        stroke-width: 8;
        stroke: @gold;
      }
    }

    .value {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: @grey9;
      font-size: 3em;
      font-weight: bold;

      i
      {
        font-size: 1.25rem;
      }

      &.highlight{
        color:@gold;
      }
    }
  }
</style>
